import { ChangeDetectionStrategy, Component } from '@angular/core';

import { FIELD_ROWS } from '../../data/walkthrough.fixtures';

/**
 * Pane 3 / 8 — `The engine · 1 of 2` (specs/auth.md §5.4).
 *
 * ---------------------------------------------------------------------------
 * ONE OF THE TWO PANES WHOSE PARAGRAPH WRAPS A CHIP — AND THE REASON THE EIGHT
 * PANES CANNOT BE ONE COMPONENT.
 *
 * The sentence contains an inline `Form Builder` chip. Pane 4 does the same
 * thing with `Process Orchestrator`, and the chip lands in a DIFFERENT PLACE:
 * near the end here, second word there — and in French, after an elided `L'`
 * with no space. A single configurable pane would have to model "where the chip
 * goes" as a prop, which is the same as admitting the two are different
 * templates (D31.3, D32).
 *
 * So the sentence is ONE message key with a `{key}` slot, rendered through
 * `| translateParts` as ordered segments. The TRANSLATION decides where the
 * chip lands; the template only says what a chip looks like. No `innerHTML`.
 * ---------------------------------------------------------------------------
 *
 * ⚠ The five field rows are a photograph of `kz-canvas-element`, the real
 * form-builder control (§12 #22). Nothing here drags, selects or focuses: the
 * `selected` row is a border, the `dropTarget` row is a dashed border, and the
 * drag handle is an icon.
 */
@Component({
  selector: 'app-walkthrough-pane3',
  standalone: false,
  templateUrl: './walkthrough-pane3.component.html',
  styleUrls: ['./walkthrough-pane3.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WalkthroughPane3Component {
  readonly fields = FIELD_ROWS;
}
